<template>
  <div class="foot">
    <div class="box">
      <div class="top clearfix">
        <div class="fl left" style="text-align: center">
          <img src="../../assets/57.jpg" alt="" width="100px">
          <h2>关注科友公众号</h2>
          <!--          <img :src="imageUrl" alt="" width="150px">-->
          <div class="share">
            <a href="#">
              <img src="../../assets/15.png" alt=""></a>
            <a href="#">
              <img src="../../assets/16.png" alt=""></a>
            <a href="#">
              <img src="../../assets/17.png" alt=""></a>
          </div>
        </div>
        <div class="fl left" style="width: 200px;margin-left: 40px;">
          <img src="../../assets/h-img1.png" alt="" width="146px">
          <h2 style="margin-top: 20px;margin-bottom: 17px;">浙江科友信息工程股份有限公司</h2>
          <div class="msg">
            <p>地址：义乌科技园区科技大楼A区9F</p>
            <p>电话：0579-85572572</p>
            <p>邮箱：keyou@zjkyou.com</p>
          </div>
        </div>
        <div class="fl clearfix foot_nav">
          <ul class="fl">
            <li class="li1">关于我们</li>
            <li><router-link to="/about#company_summary">公司简介</router-link></li>
            <li><router-link to="/about#development_history" >发展历程</router-link></li>
            <li><router-link to="/about#company_honor"  >公司荣誉</router-link></li>
            <li><router-link to="/about#corporate_culture" >企业文化</router-link></li>
            <li><router-link to="/about#cooperative_customer">合作伙伴</router-link></li>
          </ul>


          <ul class="fl">
            <li class="li1">解决方案</li>
            <li><router-link to="/solution">智慧政务</router-link></li>
            <li><router-link to="/solution">智慧教育</router-link></li>
            <li><router-link to="/solution">智慧医疗</router-link></li>
            <li><router-link to="/solution">智慧企业</router-link></li>
            <li><router-link to="/solution">IT综合运营运维管理业务</router-link></li>
            <li><router-link to="/solution">智慧交通</router-link></li>
            <li><router-link to="/solution">智慧物流园区</router-link></li>
          </ul>

          <ul class="fl">
            <li class="li1">技术服务</li>
            <li><router-link to="/technicalService#techincal_team">技术专家团队</router-link></li>
<!--            <li><router-link to="/technicalService#techincal_qualification">技术资质</router-link></li>-->
<!--            <li><router-link to="/technicalService#platform_idea">IT专家云服务平台理念</router-link></li>-->
          </ul>

          <ul class="fl">
            <li class="li1">新闻中心</li>
            <li><router-link to="/trends">公司新闻</router-link></li>
            <li><router-link to="/trends">行业动态</router-link></li>
          </ul>

          <ul class="fl">
            <li class="li1">招贤纳士</li>
            <li><router-link to="/employs#talent_concept">人才理念</router-link></li>
            <li><router-link to="/employs#social_recruitment">社会招聘</router-link></li>
            <li><router-link to="/employs#fresh_recruitment">应届招聘</router-link></li>
          </ul>

          <ul class="fl" style="width: auto;">
            <li class="li1">联系我们</li>
            <li><router-link to="/contact">客户留言</router-link></li>
            <li><router-link to="/contact">微信公众号</router-link></li>
          </ul>
        </div>
      </div>

      <div class="bom clearfix">
        <div class="left fl" style="width: 100%">
<!--          <h2>Capright @ 2017 Keyougufen All Rights Reserved</h2>-->
          <h2><span style="margin-right: 24px;">Capright @ 2017 Keyougufen All Rights Reserved</span>浙江科友信息工程股份有限公司版权所有 <a style="color: #999" href="http://beian.miit.gov.cn/" target="_blank">浙ICP备15042684号-1</a>  网站建设：<a href="http://www.keyougufen.com/">科友股份</a></h2>
        </div>

<!--        <div class="right fr">-->
<!--          <h2>服务热线:{{contactData.fphone}}</h2>-->
<!--          <h3>电子邮箱:{{contactData.femail}}</h3>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
  import axios from '../../../static/js/commonAxios'
    export default {
        name: "foot",
      data(){
          return{
            contact:'',
            baseUrl:'',
            imageUrl:'',
            contactData:''
          }
      },
      mounted(){
        this.baseUrl = process.env.API_ROOT;
       this.getContactData()
        this.getLogo()
      },
      methods:{
        getLogo(){
          axios.get(`/api/logo`).then((res) => {
            if (res.data.success) {
              this.imageUrl = this.baseUrl + res.data.items[0].flogoUrl
              console.log(this.imageUrl);
            } else {
              this.$message({
                type: 'warning',
                message: res.data.msg
              });
            }
          });
        },
        getContactData(){
          axios.get('/api/selectContactUsContent').then((res) => {
            console.log(res)
            if(res.data.success){
              this.contactData = res.data.items?res.data.items[0]:''
            }else{
              this.$message.error(res.data.msg)
            }
          })
        },
      }
    }
</script>

<style scoped>
  .foot{
    width: 100%;
    padding-top: 75px;
    background: #373a5a;
    overflow: hidden;
    position:relative;
    z-index:1000;
  }
  .foot .top{
    width: 100%;
    padding-bottom: 65px;
    border-bottom: 1px solid #696b81;
  }
  .foot .top .left h2{
    font-size: 14px;
    font-weight: 300;
    color: #9497B0;
    line-height: 24px;
    margin-top: 28px;
    margin-bottom: 23px;
  }
  .foot .top .left .share{
    /*margin-top: 60px;*/

  }
  .foot .top .left .share a{
    display: inline-block;
    width: 32px;
    height: 32px;
    margin-right: 10px;
  }
  .foot .top .left .msg p{
    font-size: 12px;
    font-weight: 300;
    color: #9497B0;
    line-height: 20px;
  }
  .foot .top .foot_nav{
    margin-left: 90px;
  }
  .foot .top .foot_nav ul{
    width: 144px;

  }
  .foot .top .foot_nav ul:nth-child(6){
    width: auto;
  }
  .foot .top .foot_nav ul li a{
    font-size: 12px;
    color: #9497B0;
    line-height: 30px;
    text-decoration: none;
  }
  .foot .top .foot_nav ul .li1{
    font-size: 14px;
    color: #dbdbdb;
    margin-bottom: 20px;
  }
  .foot .top .foot_nav ul li a:hover{
    color: #fff;
  }
  .foot .bom{
    width: 100%;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .foot .bom .left h2{
    color: #999999;
    line-height: 30px;
    font-size: 12px;
    text-align: center;
  }
  .foot .bom .left h2 a{
    color: #999999;
  }
  .foot .bom .left h2 a:hover{
    color: #fff;
  }
  .foot .bom .right h2,.foot .bom .right h3{
    color: #999999;
    line-height: 30px;
    font-size: 12px;
    padding-left: 20px;
  }
  .foot .bom .right h2{
    background: url(../../assets/18.png) no-repeat left center;
  }
  .foot .bom .right h3{
    background: url(../../assets/19.png) no-repeat left center;
  }
  .right{
    width: 650px;
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/foot/foot.vue